/*global jQuery*/
(function ($) {
    'use strict';

    $.fn.showMoreCollapse = function (option/*, varArgs*/) {
        var args = Array.prototype.slice.call(arguments, 1);

        return this.each(function () {
            var $element = $(this);
            var ctrl = $element.data('showMoreCollapse');

            if (!ctrl) {
                var opts = $.extend({},
                    $.fn.showMoreCollapse.defaults,
                    typeof option === 'object' && option
                );

                $element.data('showMoreCollapse', (ctrl = new ShowMoreCollapse(this, opts)));
            }

            if (typeof option === 'string') {
                ctrl[option].apply(ctrl, args);
            }
        });
    };

    $.fn.showMoreCollapse.defaults = {
        showCount: 0,
        /**
         * If value is class then elements with class 'hidden' will be shown.
         * If strategy is `template` then templates will used.
         * Templates are useful for content with scripts.
         * @type {('hidden'|'template')}
         */
        strategy: 'hidden'
    };

    function ShowMoreCollapse(element, options) {
        this.init(element, options);
    }

    ShowMoreCollapse.prototype = {
        constructor: ShowMoreCollapse,

        $templates: null,
        useTemplates: false,

        // Methods
        /**
         * @private
         * @param {jQuery} element
         * @param {object} options
         */
        init: function (element, options) {
            this.options = options;
            this.$element = $(element);
            this.options.strategy = this.$element.data('strategy') || this.options.strategy;
            this.useTemplates = this.options.strategy === 'template';

            if (!options.showCount) {
                options.showCount = parseInt(this.$element.data('show-count'), 10);

                if (isNaN(options.showCount)) {
                    throw 'show-more missing show count!';
                }
            }

            this.$element.on('click', '.show-more__btn', this.onShowMore.bind(this));
            this._initialDisplay();
            this._syncButtonState();
        },

        /** @private */
        onShowMore: function () {
            if (this.useTemplates) {
                var template = this.findHidden().first().remove()[0];
                this.$element.find('ul').append($(template.innerHTML));
                this.$element.find('.lazy-load-image:not([img_loaded])').lazyLoadImage();
            } else {
                this.findHidden().slice(0, this.options.showCount).removeClass('hidden');
            }

            this._syncButtonState();
        },

        findHidden: function() {
            return this.$element.find(this.useTemplates  ? 'template' : 'li.hidden');
        },

        /** @private */
        _syncButtonState: function() {
            this.$element.toggleClass('show-more-collapse--has-more', this.findHidden().length > 0);
        },

        /** @private */
        _initialDisplay: function() {
            if (!this.useTemplates) {
                var $items = this.$element.find('li');
                var showCount = this.options.showCount;

                $items.slice(0, showCount).removeClass('hidden');
                $items.slice(showCount + 1).addClass('hidden');
            }
        }
    };

    $(function () {
       $('.show-more-collapse').showMoreCollapse();
    });
})(jQuery);
